import { useToast } from '@dc-shared-web/components/shadcn/use-toast'
import { createAIUserFeedback } from '@dc-shared-web/hooks/api/ai-user-feedback/createAIUserFeedback'
import { CreateAIUserFeedbackData } from '@dc-shared-web/hooks/api/ai-user-feedback/types'
import { useSvcCrunchesContext } from '@dc-shared-web/providers/SvcCrunchesProvider'
import { useMutation, useQueryClient } from 'react-query'

export const useCreateAIUserFeedback = (params?: {
  checklist_template_uuid?: string
  question_ref_id?: string
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation(
    (feedback: CreateAIUserFeedbackData) =>
      createAIUserFeedback(apiClient, feedback, params),
    {
      onSuccess: (feedback) => {
        toast({
          variant: 'success',
          title: 'Thanks for your feedback!',
        })

        queryClient.invalidateQueries({
          queryKey: ['ai-user-feedback', `feedback-${feedback.content_uuid}`],
        })

        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error creating feedback',
          description: 'If the issue persists, please contact support.',
        })

        params?.onError?.()
      },
    }
  )
}
